/**
 * @author Iulian Ceapa <dev@sitemd.net>
 * @copyright © 2019-2025 SiteMD.
 */

function checkScreenWidth() {
    const viewport = document.querySelector('meta[name="viewport"]');
    viewport.setAttribute('content', 'width=' + (screen.width <= 330 ? '330' : 'device-width, height=device-height, initial-scale=1'));
}

window.addEventListener('DOMContentLoaded', checkScreenWidth);
window.addEventListener('resize', checkScreenWidth);

$(function () {
    let prev_scroll = window.scrollY;
    const header = $('header');
    const header_logo = $('.navbar-brand img');
    const hide_threshold = 100;

    const default_logo = window.location.origin + "/dist/app/media/img/logo-white.svg";
    const fixed_logo = window.location.origin + "/dist/app/media/img/logo-color.svg";

    // Initial setup if the scroll position is not at 0
    if (prev_scroll > 0) {
        header.addClass('header-fixed');
        header_logo.attr('src', fixed_logo);
    }

    $(window).scroll(function () {
        let current_scroll = window.scrollY;

        // Handling negative scroll values (Safari macOS)
        current_scroll = Math.max(0, current_scroll);
        prev_scroll = Math.max(0, prev_scroll);

        // Hiding or displaying the menu based on the scroll direction
        if (current_scroll > hide_threshold && current_scroll > prev_scroll) {
            header.addClass('hide');
        } else {
            header.removeClass('hide').addClass('header-fixed');
            header_logo.attr('src', fixed_logo);
            if (current_scroll === 0) {
                header.removeClass('header-fixed');
                header_logo.attr('src', default_logo);
            }
        }
        prev_scroll = current_scroll;
    });
});

document.querySelectorAll('.anchor').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
        const url = new URL(this.href);
        const current = window.location;

        // verifici dacă e aceeași pagină (fără hash)
        const is_same_page =
            url.pathname === current.pathname &&
            url.hostname === current.hostname;

        if (is_same_page && url.hash) {
            e.preventDefault();

            gsap.to(window, {
                duration: 0,
                scrollTo: {
                    y: url.hash,
                    offsetY: 50
                }
            });
        }
    });
});